module.exports = __webpack_public_path__ + "static/media/reply.423fa5a4.svg";